import React, { useCallback, useRef, useState } from 'react';
import clsx from 'clsx';
import { Grid, Button, makeStyles } from '@material-ui/core';
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      borderRadius: 4,
      border: "1px solid ".concat(theme.palette.primary.main),
      borderLeft: 'none',
      overflow: 'hidden',
      alignItems: 'stretch'
    },
    item: {
      overflow: 'hidden'
    },
    button: {
      color: theme.palette.text.secondary,
      borderRadius: 0,
      height: '100%',
      width: '100%',
      textTransform: 'none',
      borderLeft: "1px solid ".concat(theme.palette.primary.main),
      '&:hover': {
        background: theme.palette.background.default
      },
      whiteSpace: 'nowrap',
      '& span': {
        whiteSpace: 'nowrap'
      }
    },
    selected: {
      background: theme.palette.primary.main,
      color: '#fff',
      '&:hover': {
        background: theme.palette.primary.main
      }
    },
    light: {
      background: theme.palette.primary.light,
      color: theme.palette.primary.main,
      '&:hover': {
        background: theme.palette.primary.light
      }
    }
  };
});

var useControlled = function useControlled(_a) {
  var controlled = _a.controlled,
      defaultProp = _a.default;
  var isControlled = useRef(controlled !== undefined).current;

  var _b = useState(defaultProp),
      valueState = _b[0],
      setValue = _b[1];

  var value = isControlled ? controlled : valueState;
  var setValueIfUncontrolled = useCallback(function (v) {
    if (isControlled) {
      setValue(v);
    }
  }, []);
  return [value, setValueIfUncontrolled];
};

var sizeObj = {
  lg: 240,
  md: 180,
  sm: 120,
  auto: '100%'
};

var ButtonGroups = function ButtonGroups(props) {
  var valueProp = props.value,
      options = props.options,
      light = props.light,
      _a = props.size,
      size = _a === void 0 ? 'auto' : _a,
      autoWidth = props.autoWidth,
      onChange = props.onChange;
  var classes = useStyles();

  var _b = useControlled({
    controlled: valueProp,
    default: valueProp
  }),
      value = _b[0],
      setValue = _b[1];

  function handleChange(value) {
    setValue(value);
    onChange && onChange(value);
  }

  return React.createElement(Grid, {
    container: true,
    alignItems: "center",
    className: classes.root,
    style: {
      width: sizeObj[size] || '100%'
    }
  }, options.map(function (option) {
    return React.createElement(Grid, {
      item: true,
      className: classes.item,
      xs: !autoWidth,
      key: option.value
    }, React.createElement(Button, {
      size: "small",
      onClick: function onClick() {
        return handleChange(option.value);
      },
      className: clsx(classes.button, option.value === value ? classes.selected : null, option.value === value && light && classes.light)
    }, typeof option.label === 'string' || typeof option.label === 'number' ? React.createElement("span", null, option.label) : option.label));
  }));
};

export default ButtonGroups;